module.exports = __webpack_public_path__ + "public/img/carImg.64fc050b.png";